export default __webpack_public_path__ + "7a8139a5996a4b6ac3e98c04d017ef2c.svg";